import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseIncreaseTefTableVersion {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useIncreaseTefTableVersion = ({ id, onSuccess, onError }: UseIncreaseTefTableVersion) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['increaseTefTableVersion'],
    mutationFn: async () => {
      return await privateAxios.put(`/establishment/company_branches/${id}/increase_fiserv_tef_dataset_table_version`)
    },
    onSuccess,
    onError
  })
}

export default useIncreaseTefTableVersion
